<template>
    <div class="ivu-select ivu-select-single" :class="{'ivu-select-visible':isFocus}" v-if="isDisplay">
        <div class="ivu-select-selection">
            <input type="text" class="ivu-select-input" placeholder="请选择" @focus="inputFocus" @blur="inputBlur" v-model="label" @input="input">
            <i class="ivu-select-arrow ivu-icon ivu-icon-ios-arrow-down"></i>
        </div>
        <div class="ivu-select-dropdown slide-up-transition" style="width:100%;transform-origin: center top 0px;"
            :x-placement="{'bottom-start':isFocus}" :style="{'display': isFocus?'block':'none'}">
            <ul class="ivu-select-not-found" v-show="itemList.length < 1"><li>无匹配数据</li></ul>
            <ul class="ivu-select-dropdown-list" v-show="itemList.length > 0">
                <li class="ivu-select-item" v-for="(item, i) in itemList"
                    @click="handleChange(item)"
                    :class="{'ivu-select-item-selected': value == item.value}" :key="i">{{item.label}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
	/**
     * 可搜索的下拉选择组件   为显示面板与输入框一样宽 需在外面套一层 <i-col span='5'></i-col> span 值按需调整
     * －－－－－－－－－－－－
     * 数据返回固定格式: [{
     *      label: 'XX',
     *      value: 1
     * }]
     *
     */
    import PageSubmitMixin from "@/utils/pageSubmit.mixin";
    export default {
        name: 'LySearchSelect',
        mixins: [PageSubmitMixin],
    	props: {
            page: {
                type: Object,
                default: _ => {}
            },
            value: {
                type: [String, Number],
                default: ''
            },
            isGiveLabel: {
                type: Boolean,
                // default: true
                default: false
            }, // 2020-08-20 by zjs 没找到这个东西，在项目哪用到过，如果出问题了，应该把它写到配置中
            attrs: {
                type: Object,
                default: _ => new Object()
            },
            pageData: { // 2018-11-05添加，这个组件在dialog-button中，搜索时要根据当前页面的一个字段去搜索，需要将页面数据传过来
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return {
                isFocus: false,
                backuplabel: '', // 备份
                label: '',
                itemList: [],
                id: '', // 要查询的id
                isIdSearch: false, // 标识是否根据ID查询了
                isInitBind: false,
                params: {}//接口上传数据
            }
        },
        created () {
            this.label = ''  //清空数据
            this.queryItems()
            console.log('page:%O', this.page)
        },
        mounted() {
            this.$eventHub.$emit(this.attrs.field + "Event", this.value)// 全局监听 modify by wxf 2018-11-13
        },
        watch: {
            value:  {
                handler () {
                    this.initBindLabel()
                    this.$eventHub.$emit(this.attrs.field, this.value)// 全局监听 modify by wxf 2018-11-13
                },
                immediate: true
            }
        },
        computed: {
            /**
             * 2021-09-06 这里之前没用使用display来判断显示的问题
             * 因为今天用到，要监听同表单中的值变化，来控制是否显示，所以这里是表单中判断的，而不是根据返回的数据状态判断
             * 这里只判断一种，display == 指定的值就行了
             */
            isDisplay () {
                let bool = true

                if (String(this.attrs.status).length > 0 && this.attrs.linkField.length > 0) {
                    this.attrs.status = bool = this.page[this.attrs.linkField] == this.attrs.display

                }

                return bool
            }
        },
        methods: {
            /**
             * 单选项列表的获取
             */
            queryItems () {
                if (!this.attrs.api || this.attrs.api.length < 1) return
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    // 解析api
                    let api = this.$path.getPath(this.attrs.api, this.pageData)

                    // 优化联动选择下拉 设置上传参数 modify by wxf 2019-11-13
                    this.params = {
                        keyword: this.label,
                        id: this.id
                    }

                    this.$api.query(api, this.params).then((rs) => {
                        this.itemList = rs
                        this.isIdSearch = true
                        this.initBindLabel()
                        // 将当前输入框内容，传递
                        if (this.isGiveLabel) {
                            this.$emit('input', this.label)
                        }
                    }).catch((err) => {
                        console.log('err:%O', err)
                    })
                }, 500)
            },
            /**
             * 初始化默认绑定的值
             */
            initBindLabel () {
                this.id = ''
                if (String(this.value).length > 0 && !this.isInitBind) {

                    let index = this.itemList.findIndex ((el) => {
                        return el.value === this.value
                    })
                    if (index >= 0) {
                        this.isInitBind = true
                        this.label = this.backuplabel = this.itemList[index]['label']
                    } else if (!this.isIdSearch && !isNaN(this.value)){// 如果没有匹配上，根据ID再查询一次
                        this.isIdSearch = true
                        this.id = this.value
                        this.queryItems()
                    }
                    //  this.label = this.backuplabel = this.value
                }
            },
            /**
            * 选中对象
            */
            handleChange (val) {
                this.$emit('input', val.value)
                this.label = val.label
                this.backuplabel = val.label
                if(this.attrs.isTxtLink) {
                    this.$eventHub.$emit(this.attrs.field + "LinkEvent", val)// 全局监听 modify by wxf 2018-11-13
                }
            },
            /**
            * 获取焦点
            */
            inputFocus () {
                this.isFocus = true
            },
            /**
            * 失去焦点
            */
            inputBlur () {
                let vm = this
                // this.label = this.backuplabel
                setTimeout(function(){
                    vm.isFocus = false
                },150)
            },
            /*
            * 手动输入搜索
            */
            input () {
                if (this.isFocus) {
                    this.queryItems()
                }
            }
        }
    }
</script>
<style>
    .ivu-icon-ios-arrow-down:before {
        content: "\F116";
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/search-select/src/index.vue